import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface EapSettingsListContextType {
    configurations: EapSettings[];
    isLoading: boolean;
    selectedRows: EapSettings[];
    refreshList: VoidFunction;
    setSelectedRows: Dispatch<SetStateAction<EapSettings[]>>;
}

export const EapSettingsListContext = createContext<EapSettingsListContextType | undefined>(undefined);
